import {
  faCircleNotch,
  faCode,
  faHandPointer,
  faLightCeiling,
  faListCheck,
  faTrophy,
  faUserCheck,
  IconDefinition,
} from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Badge } from '@windmill/react-ui';

import { SolutionPhase } from '../../common/api/models/solution';

type BadgeType = 'success' | 'danger' | 'warning' | 'neutral' | 'primary';

interface SolutionPhaseDisplayProps {
  phase: SolutionPhase;
}

export const SolutionPhaseDisplay: React.FunctionComponent<
  SolutionPhaseDisplayProps
> = ({ phase }) => {
  const [icon, text, type] = getPhaseDisplayText(phase);
  return (
    <Badge className="flex items-center py-1 px-3" type={type}>
      <FontAwesomeIcon icon={icon} />
      <span className="ml-2">{text}</span>
    </Badge>
  );
};

const getPhaseDisplayText = (
  phase: SolutionPhase
): [IconDefinition, string, BadgeType] => {
  switch (phase) {
    case SolutionPhase.DEPRECIATED:
      return [faLightCeiling, 'Deprecated', 'danger'];
    case SolutionPhase.DRAFT:
      return [faCircleNotch, 'Defined', 'warning'];
    case SolutionPhase.INTERNAL_PUBLISH_REVIEW:
      return [faListCheck, 'In Review for Publishing', 'neutral'];
    case SolutionPhase.LIVE:
      return [faUserCheck, 'Live', 'success'];
    case SolutionPhase.MARKETPLACE_PUBLISH_REVIEW:
      return [faListCheck, 'In Review for Publishing', 'neutral'];
    case SolutionPhase.READY_TO_PUBLISH:
      return [faTrophy, 'Ready to Publish', 'primary'];
    case SolutionPhase.TECH_REVIEW:
      return [faCode, 'In Tech Review', 'neutral'];
    case SolutionPhase.SOLUTION_PHASE_UNSPECIFIED:
      return [faHandPointer, 'Registered', 'warning'];
    default:
      return [faHandPointer, 'Registered', 'warning'];
  }
};
